interface Props {
  width: number;
  height: number;
}

const LogoSmall = ({ width, height }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 48 48"
    className="text-[#293329] opacity-60"
  >
    <g fill="currentColor" clipPath="url(#clip0_119_3767)">
      <path d="M48 19.56v-6.668l-16.31 6.667H48zM17.248 25.464V48H30.75V25.464L24 22.704l-6.752 2.76zM0 22.582v6.668l16.309-6.668H0zM0 12.892v6.668h16.309L0 12.892zM14.225 26.7L0 32.515V48h14.225V26.7zM33.774 26.7V48H48V32.515L33.774 26.7zM48 29.25v-6.668H31.69L48 29.25zM24 19.438l24-9.812V0H0v9.626l24 9.812z"></path>
    </g>
    <defs>
      <clipPath id="clip0_119_3767">
        <path fill="#fff" d="M0 0H48V48H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default LogoSmall;
